import TitledText from "./TitledText.js";

export default TitledText;
